import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Http, RequestOptionsArgs, RequestOptions } from '@angular/http'

import { Observable } from 'rxjs/Observable'

import { MessagesDelegate } from './messages-delegate.service'

interface IApiOptions {
  enableBeforeAfter: boolean
}

@Injectable()
export class ApiService {

  public httpOptions = new RequestOptions({ withCredentials: true })
  private apiOptions: IApiOptions = { enableBeforeAfter: true }
  private beforeQuery = null
  private afterQuery = null

  constructor (private http: Http, private router: Router, private messagesDelegate: MessagesDelegate) {
    this.get = this.get.bind(this)
    this.post = this.post.bind(this)
    this.errorHandler = this.errorHandler.bind(this)
  }

  get (url: string, httpOpt?: RequestOptions, apiOpt?: IApiOptions) {
    return this.request('get', url, null, httpOpt, apiOpt)
  }

  post (url: string, body: object, httpOpt?: RequestOptions, apiOpt?: IApiOptions) {
    return this.request('post', url, body, httpOpt, apiOpt)
  }

  put (url: string, body: object, httpOpt?: RequestOptions, apiOpt?: IApiOptions) {
    return this.request('put', url, body, httpOpt, apiOpt)
  }

  delete (url: string, httpOpt?: RequestOptions, apiOpt?: IApiOptions) {
    return this.request('delete', url, null, httpOpt, apiOpt)
  }

  request (
    method: 'get' | 'post' | 'put' | 'delete',
    url: string,
    body: Object = null,
    httpOpt?: RequestOptions,
    apiOpt?: IApiOptions) {
    httpOpt = httpOpt || this.httpOptions
    apiOpt = apiOpt || this.apiOptions

    if (this.beforeQuery && apiOpt.enableBeforeAfter) {
      this.beforeQuery()
    }

    const request = method === 'get' || method === 'delete'
      ? this.http[method](url, httpOpt)
      : this.http[method](url, body, httpOpt)

    return request.toPromise()
      .then(response => {
        if (this.afterQuery && apiOpt.enableBeforeAfter) {
          this.afterQuery()
        }

        // response.json() may exist and throw error if invalid json
        try {
          return response.json()
        } catch (e) {
          return response
        }
      })
      .catch(this.errorHandler)
  }

  errorHandler (errData) {
    let error

    try {
      error = errData.json()
    } catch (e) {
      error = errData
    }

    if (this.afterQuery) {
      this.afterQuery()
    }

    // intercept 401 & 403
    if (error.code === 401) {
      this.messagesDelegate.add(error.message, true)
      this.router.navigate(['/login'])

      // return empty data
      return null
    } else if (error.code === 403) {
      this.messagesDelegate.add(error.message, true)
      return null
    }

    // provide error to the susbcribers
    throw (error)
  }

  setBeforeQuery (fn) {
    if (typeof fn !== 'function') return

    this.beforeQuery = fn
  }

  setAfterQuery (fn) {
    if (typeof fn !== 'function') return

    this.afterQuery = fn
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/services/api.service.ts